const LOAD_DATA_MASTER_SUB_DISTRICT         = 'LOAD_DATA_MASTER_SUB_DISTRICT'
const LOAD_DATA_MASTER_SUB_DISTRICT_SUCCESS = 'LOAD_DATA_MASTER_SUB_DISTRICT_SUCCESS'
const LOAD_DATA_MASTER_SUB_DISTRICT_FAILED  = 'LOAD_DATA_MASTER_SUB_DISTRICT_FAILED'
const UNMOUNT_DATA_MASTER_SUB_DISTRICT      = 'UNMOUNT_DATA_MASTER_SUB_DISTRICT'

const initialState = {
  loading: true,
  data: null,
  message: null,
  meta: null
}

const subDistrictReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_DATA_MASTER_SUB_DISTRICT:
      return {
        ...state,
        loading: true,
        data: null,
        meta: null
      }
    case LOAD_DATA_MASTER_SUB_DISTRICT_SUCCESS:
      return {
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
        meta: action.payload.meta
      }
    case LOAD_DATA_MASTER_SUB_DISTRICT_FAILED:
      return {
        ...state, 
        loading: false,
        data: null,
        message: 'FAILED',
        meta: null
      }
    case UNMOUNT_DATA_MASTER_SUB_DISTRICT:
      return { 
        ...state, 
        loading: true,
        data: null,
        meta: null
      }
    default:
      return state
  }
}
export default subDistrictReducer